import { render } from "./SystemNotices.vue?vue&type=template&id=fe2ba714&scoped=true"
import script from "./SystemNotices.vue?vue&type=script&lang=js"
export * from "./SystemNotices.vue?vue&type=script&lang=js"

import "./SystemNotices.vue?vue&type=style&index=0&id=fe2ba714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe2ba714"]])

export default __exports__